module.exports = __webpack_public_path__ + "static/media/LCD-prosessi-vaaka-fi.2a00f74a.svg";